import React from 'react';
import BlockWrapper from './BlockWrapper';
import ImageSlider from '../ImageSlider/ImageSlider';

const ImageSliderBlock = ({ block }) => {
  return (
    <BlockWrapper>
      <ImageSlider items={block.images} />
    </BlockWrapper>
  );
};

export default ImageSliderBlock;
